type TRouteParams = Record<string, string | string[] | undefined>;

interface IRouteParam {
  value: string,
  placeholder: string,
}

const UNRESOLVED_ROUTE = '/[unresolved]';

const isRouteGroup = (segment: string): boolean => segment.startsWith('(') && segment.endsWith(')');

const toRouteParam = ([name, value]: [string, string | string[] | undefined]): IRouteParam => (
  Array.isArray(value)
    ? { value: value.join('/'), placeholder: `[...${ name }]` }
    : { value: value ?? '', placeholder: `[${ name }]` }
);

const claimSegment = (route: string[], unclaimed: (string | null)[], param: IRouteParam): boolean => {
  const index = unclaimed.lastIndexOf(param.value);

  if (index === -1) {
    return false;
  }

  unclaimed[index] = null;
  route[index] = param.placeholder;

  return true;
};

export const toRoutePattern = (segments: string[] | null, params: TRouteParams | null): string => {
  const route = [...(segments ?? [])];
  const unclaimed: (string | null)[] = [...route];
  const isResolved = Object.entries(params ?? {})
    .map(toRouteParam)
    .filter(({ value }) => value.length > 0)
    .reverse()
    .every((param) => claimSegment(route, unclaimed, param));

  if (!isResolved) {
    return UNRESOLVED_ROUTE;
  }

  const path = route.filter((segment) => !isRouteGroup(segment)).join('/');

  return path.startsWith('/') ? path : `/${ path }`;
};
